import axios from "axios";
import { Fragment, useEffect, useState } from "react"
import "./Home.css";
import "./card.css"
import Bestseller from "./Bestseller";
import Metadata from "./Metadata";
import { useDispatch, useSelector } from "react-redux";
import Bestsellerslice from "../store/Bestsellerslice";
import Loader from "./Loader";




const Homeseller = () => {
    const dispatch = useDispatch();
    const sellervalue = useSelector((store) => {
        return store.bestseller.products

    })
    const loader = useSelector((store) => {
        return store.bestseller.loading

    })


    useEffect(() => {
        dispatch(Bestsellerslice.actions.productsrequest())
        axios.get("https://retoolapi.dev/OjbvTJ/bestseller/")
            .then(response => dispatch(Bestsellerslice.actions.productssuccess(response.data)))
            .catch(err => console.log(err))


    }, []);


    return (
        <Fragment>
            {loader ? <Loader> </Loader> :
                <div className="frames">
                    <Metadata title={"Bestseller-Leegifts"}> </Metadata>
                    {sellervalue.map((ele, idx) => {
                        return (
                            <Bestseller key={idx} img={ele.img} title={ele.title} price={ele.price} id={ele.id} num={ele.num}> </Bestseller>
                        )
                    })}


                </div>}
        </Fragment>

    )


}
export default Homeseller;